import { observer } from 'mobx-react';
import React, { useContext, useEffect, useState } from 'react';
import ChooseContentStor from '@/packages/content/view/contentLibrary/stor/ChooseContentStor';
import { Cascader, Radio, Select, Spin } from 'antd';
import { COURSEWARE_OPERATION_MODES, KV } from 'common/constant/filters';
import styled from 'styled-components';

const Title = styled.div`
  font-weight: 600;
  margin-bottom: 10px;
`;

export default observer(props => {
  const { node, isCatalog, value, onChange } = props;
  const chooseContentStor = useContext(ChooseContentStor);
  const [loading, setLoading] = useState(false);
  const { courseSeries } = nx.$root.catalog;

  useEffect(() => {
    setLoading(!courseSeries.length);
  }, [courseSeries]);

  const {
    fetchCourseList,
    fetchCatalogList,
    courseList,
    courseSeriesUuid,
    setCourseSeriesUuid,
    catalogs,
    isMove,
    setIsMove,
    setContentCreatable,
    goalCourseUuid,
    goalCatalogUuids,
    nodeResponses,
    goalNodeResponsesUuids,
    setNodeResponses,
    setGoalCourseUuid,
    setGoalCatalogUuids,
    setGoalNodeResponsesUuids,
  } = chooseContentStor;

  const target = { value };

  const chooseSelectStyle = {
    width: '100%',
    marginBottom: '20px',
  };

  return (
    <Spin spinning={loading}>
      <Title>至课程</Title>
      <Select
        optionFilterProp="children"
        showSearch={true}
        placeholder="请选择目标课程系列"
        value={courseSeriesUuid}
        style={chooseSelectStyle}
        onSelect={(value: string) => {
          fetchCourseList(value);
          setCourseSeriesUuid(value);
          setGoalCourseUuid(undefined);
          setGoalCatalogUuids([]);
          setGoalNodeResponsesUuids([]);
          setContentCreatable(false);
          onChange({ target });
        }}>
        {courseSeries.map((courseGroupItem: any) => {
          return (
            <Select.Option value={courseGroupItem.uuid} key={courseGroupItem.uuid}>
              {courseGroupItem.cnName}
            </Select.Option>
          );
        })}
      </Select>
      <Select
        optionFilterProp="children"
        showSearch={true}
        placeholder="请选择目标课程"
        value={goalCourseUuid}
        style={chooseSelectStyle}
        onSelect={(value: string) => {
          setGoalCourseUuid(value);
          setGoalCatalogUuids([]);
          setGoalNodeResponsesUuids([]);
          fetchCatalogList(value);
          // 在顶层目录下操作 select
          // {"targetCourseUuid":"5a1a3ccfe24ebccfc1a361aefcc2f03b","targetParentUuid":"cd5f32297ddb8ac61572681c3f4c57b3"}
          if (isCatalog) {
            target.value.targetCourseUuid = value;
            node.level === 1 && setContentCreatable(!!value);
          }
          onChange({ target });
        }}>
        {courseList.map((courseItem: any) => {
          return (
            <Select.Option value={courseItem.uuid} key={courseItem.uuid}>
              {courseItem.cnName}
            </Select.Option>
          );
        })}
      </Select>

      {(!isCatalog || (isCatalog && node.level === 2)) && (
        <React.Fragment>
          <Title>至章节</Title>
          <Cascader
            showSearch={true}
            options={catalogs}
            placeholder="请选择目标目录"
            value={goalCatalogUuids}
            style={chooseSelectStyle}
            changeOnSelect={true}
            fieldNames={{ label: 'title', value: 'uuid', children: 'children' }}
            onChange={(value, selectedOptions) => {
              let targetValue = null;
              let _nodeResponses: any = [];
              if (value.length > 0) {
                targetValue = selectedOptions[selectedOptions.length - 1];
                _nodeResponses = targetValue.businessResponses || [];
                nx.deepEach(_nodeResponses, (key: any, value: any, item: any) => {
                  if (!item.uuid) {
                    item.uuid = item.businessConfigUuid;
                  }
                  if (item.businessConfigUuid !== node.businessConfigUuid) {
                    item.disabled = true;
                  }
                  if (value.constructor === Object && (value.level || -1) >= node.level) {
                    delete item[key];
                  }
                });
                setNodeResponses(_nodeResponses);
              }

              nx.set(target, 'value.uuid', value[value.length - 1]);
              setGoalCatalogUuids(value);

              if (isCatalog) {
                setContentCreatable(!!value.length);
                if (isCatalog && node.level === 2) {
                  target.value.targetParentUuid = value[value.length - 1];
                }
              } else {
                if (!node.level) {
                  setContentCreatable(!!value.length && !targetValue.children);
                }
              }
              setGoalNodeResponsesUuids([]);
              onChange({ target });
            }}
          />
        </React.Fragment>
      )}
      {!isCatalog && node.level && (
        <Cascader
          showSearch={true}
          options={nodeResponses}
          placeholder="请选择目标层级"
          value={goalNodeResponsesUuids}
          style={chooseSelectStyle}
          changeOnSelect={true}
          fieldNames={{
            label: 'name',
            value: 'uuid',
            children: 'nodeResponses',
          }}
          onChange={(value, selectedOptions) => {
            const _goalNode = selectedOptions[selectedOptions.length - 1];
            setContentCreatable(
              !!value.length &&
                _goalNode.businessConfigUuid === node.businessConfigUuid &&
                (_goalNode.level || 0) === node.level - 1
            );
            setGoalNodeResponsesUuids(value);
            onChange({ target });
          }}
        />
      )}
      <Title>选择操作</Title>
      <nx.$rc.radioGroup
        items={COURSEWARE_OPERATION_MODES}
        value={isMove}
        onChange={e => {
          nx.set(target, 'value.isMove', e.target.value);
          setIsMove(e.target.value);
          onChange({ target });
        }}
        template={mode => {
          const { value, label }: KV = mode.item;
          return (
            <Radio key={value} disabled={value && node.publishStatus === 'PUBLISHED'} value={value}>
              {label}
            </Radio>
          );
        }}
      />
    </Spin>
  );
});
